import React from 'react';
import { NavLink, Outlet, Link, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  ShieldAlert,
  LayoutDashboard,
  Users,
  Receipt,
  FileText,
  Boxes,
  CreditCard,
  Coins,
  Server,
  ArrowLeft,
  UserCheck,
  FolderKanban
} from 'lucide-react';

export const AdminLayout = () => {
  const { isAdmin, loading } = useAuth();

  if (loading) return null;
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  const adminTabs = [
    { to: '/admin', label: 'Resumen Global', icon: LayoutDashboard, end: true },
    { to: '/admin/users', label: 'Usuarios', icon: Users },
    { to: '/admin/invoices', label: 'Facturas', icon: Receipt },
    { to: '/admin/quotes', label: 'Cotizaciones', icon: FileText },
    { to: '/admin/customers', label: 'Clientes', icon: UserCheck },
    { to: '/admin/projects', label: 'Proyectos', icon: FolderKanban },
    { to: '/admin/inventory', label: 'Inventario', icon: Boxes },
    { to: '/admin/subscriptions', label: 'Suscripciones', icon: CreditCard },
    { to: '/admin/currencies', label: 'Monedas', icon: Coins },
    { to: '/admin/system', label: 'Sistema & Caché', icon: Server },
  ];

  return (
    <div className="space-y-6">
      {/* Admin Top Header Banner */}
      <div className="bg-gradient-to-r from-teal-900 to-slate-900 text-white rounded-2xl p-6 shadow-md border border-teal-800/50 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-center gap-3.5">
          <div className="p-3 bg-white/10 rounded-xl border border-white/20">
            <ShieldAlert className="w-6 h-6 text-amber-400" />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-lg font-bold">Panel de Administración Quinvoice</h1>
              <span className="px-2 py-0.5 bg-rose-500 text-white text-[10px] font-extrabold rounded-md uppercase tracking-wider">
                Root Admin
              </span>
            </div>
            <p className="text-xs text-teal-200 mt-0.5">
              Control global del sistema, gestión de usuarios, inventario general y diagnóstico de la API.
            </p>
          </div>
        </div>

        <Link
          to="/"
          className="inline-flex items-center gap-2 px-3.5 py-2 rounded-xl bg-white/10 hover:bg-white/20 text-xs font-semibold text-white transition-colors border border-white/10"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver a la App
        </Link>
      </div>

      {/* Admin Nav Tabs */}
      <div className="overflow-x-auto pb-1">
        <div className="flex items-center gap-1.5 p-1 bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 rounded-2xl w-max min-w-full sm:min-w-0 shadow-sm">
          {adminTabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <NavLink
                key={tab.to}
                to={tab.to}
                end={tab.end}
                className={({ isActive }) => `
                  flex items-center gap-2 px-3.5 py-2 rounded-xl text-xs font-semibold whitespace-nowrap transition-all
                  ${isActive
                    ? 'bg-brand-600 text-white shadow-sm font-bold'
                    : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-800'}
                `}
              >
                <Icon className="w-3.5 h-3.5" />
                {tab.label}
              </NavLink>
            );
          })}
        </div>
      </div>

      {/* Admin Content Outlet */}
      <div className="animate-fade-in">
        <Outlet />
      </div>
    </div>
  );
};
